import React, {PropTypes} from "react"
import { Tooltip, Row } from "antd"
import warningIcon from "app/styles/images/sp/data-warning.svg"
import "./WarningTip.scss"

/*
 * mainKeys, headers 顺序必须对应
 */
export default class WarningTip extends React.Component {
  render() {
    const { text, historyData, onVisibleChange, justify, mainKeys, headers } = this.props
    const headerObject = {}, disposedData = {}
    mainKeys.forEach((key, index) => {
      headerObject[key] = headers[index]
      disposedData[key] = []
    })

    const dataList = [headerObject, ...historyData]

    dataList.forEach(item => {
      mainKeys.forEach(key => disposedData[key].push(item[key]))
    })

    return (
      <Row type="flex" justify={justify} align="middle" className="edited-wrap edited-warning">
        <div className="text ellipsis">{text}</div>
        <Tooltip
          overlayClassName="pgx-warning-tip"
          placement="bottomLeft"
          onVisibleChange={onVisibleChange}
          title={(
            <Row
              className="edited-history-single"
              type="flex"
              gutter={20}>
              {mainKeys.map(key =>
                <div key={key} className="column">
                  {disposedData[key].map((column, index) => <div key={column + "" + index}>{column}</div>)}
                </div>
              )}
            </Row>
          )}>
          <img className="cursor-p" alt="" src={warningIcon} />
        </Tooltip>
      </Row>
    )
  }
}

WarningTip.propTypes = {
  mainKeys: PropTypes.array
}

WarningTip.defaultProps = {
  mainKeys: ["versionNum", "groupName", "createTime"],
  headers: ["版本", "编辑内容", "编辑时间"]
}



// WEBPACK FOOTER //
// ./src/app/components/normal/WarningTip/WarningTip.js